module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-1.5ec8d3fb.png";